<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="isLoading">
            <CircleProgress/>
          </div>
        </transition>

        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="!isLoading">
            <OrderProductsTable
                :perPage="20"
            />
          </div>
        </transition>
      </div>

      <OrderEditorModal
          :show="showOrderModal"
          :order-id="null"
          @close="closeOrderModal"
          @saved="onOrderSaved"
      />
    </div>
  </div>
</template>

<script>
import CircleProgress from "./components/CircleProgress.vue";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import velocity from "velocity-animate";
import '@/assets/css/OrdersTable.css';
import OrderProductsTable from "@/views/components/OrderComponents/OrderProductsTable.vue";
import OrderEditorModal from "@/views/components/Form/OrderEditorModal.vue";

export default {
  name: "OrdersTable",
  components: {
    OrderProductsTable,
    OrderEditorModal,
    CircleProgress
  },
  data() {
    return {
      years: [],
      count: 0,
      showOrderModal: false
    };
  },
  computed: {
    isLoading: {
      get() {
        return this.$store.state.isOrderDataLoading;
      },
    },
    filterStatusId: {
      get() {
        return this.$store.state.filterOrderByStatusId;
      }
    },
    searchOrderName: {
      get() {
        return this.$store.state.searchOrderName;
      }
    },
    filterOrderByDate: {
      get() {
        return this.$store.state.filterOrderByDate;
      }
    },
    filterOrderByDateStart: {
      get() {
        return this.$store.state.filterOrderByDateStart;
      }
    },
    arendaOrderStart: {
      get() {
        return this.$store.state.arendaOrderStart;
      }
    },
    arendaOrderEnd: {
      get() {
        return this.$store.state.arendaOrderEnd;
      }
    },
    sezon: {
      get() {
        return this.$store.state.sezon;
      }
    },
    orderListSize: {
      get() {
        return this.$store.state.orderListSize;
      }
    },
    orderPaginationStart: {
      get() {
        return this.$store.state.orderPaginationStart;
      }
    },
  },
  methods: {
    closeOrderModal() {
      this.showOrderModal = false;
    },

    onOrderSaved() {
      this.closeOrderModal();
      this.fetchData();
    },

    setIsLoading(active) {
      this.$store.commit('updateIsOrderDataLoading', active);
    },

    beforeEnter(el) {
      el.style.opacity = 0;
    },

    enter(el, done) {
      velocity(el, { opacity: 1 }, { duration: 500, complete: done });
    },

    leave(el, done) {
      velocity(el, { opacity: 0 }, { duration: 500, complete: done });
    },
  },
  mounted() {
    this.setIsLoading(false);
  },
};
</script>